export const injectElementIntoContainer = (element, container) => {
  container.appendChild(element);

  // return cleanup function
  return () => {
    container.removeChild(element);
  };
};